export function handleResponse(response) {
    return response.text().then(text => {
        if (!response.ok) {

            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                console.log(response.status + " received and logged out");
                if (process.env.PUBLIC_URL === '.'){
                    window.location.href = '/logout';
                }
                else{
                    window.location.href = `${process.env.PUBLIC_URL}/logout`;
                }
            }
            return Promise.reject(text);
        }
        const data = text && JSON.parse(text);
        return data;
    });
}